import { render } from "./TrainingsView.vue?vue&type=template&id=eccb2f80"
import script from "./TrainingsView.vue?vue&type=script&lang=js"
export * from "./TrainingsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__